import Swal from 'sweetalert2'

import { userInputFlowHtml } from './userInputFlowHtml'
import { sweetAlertCommonParams,selectedOptionsTextArray } from '../../utils/functions'
import { lang } from '../../assets/lang'

export const userInputFlowModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.user_input_flow_modal_title,
    html: userInputFlowHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      // TODO
      // Load User input flow list via ajax
      // Dump select options
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

      $('#inputflow-webhook-url').val(oldData.buttonWebhookUrl || '')

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_userinput_flow_list',
        dataType: 'JSON',
        data: { page_table_id, instagram_bot_addon },
        success:function(response) {
          const userInputFlowListElement = $("#user-input-flow-list")

          userInputFlowListElement.html(response.dropdown_str);
          userInputFlowListElement.prepend(new Option("Add new input flow", "new"));

          userInputFlowListElement.val(oldData.userInputFlowIdValue || '').change()
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_google_sheets',
        dataType: 'JSON',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-CSRF-TOKEN', window.xitFlowBuilderData.csrf_token);
        },
        success:function(response) {
          $("#inputflow-google-sheets").html(response.googleSheets);
          $('#inputflow-google-sheets').val(oldData.googleSheets || '').trigger('change')
        }
      })

      const userInputFlowListElement = $('#user-input-flow-list')
      const userInputFlowFieldsElement = $('#user-input-flow-fields')
      const campaignNameElement = $('#campaign-name')

      function toggleUserInputFlowList(selectedUserInputFlow, oldData) {
        if ('new' === selectedUserInputFlow) {
          userInputFlowFieldsElement.removeClass('d-none').addClass('d-block')
          campaignNameElement.val(oldData.campaignName || '')
        } else {
          userInputFlowFieldsElement.removeClass('d-block').addClass('d-none')
        }
      } 

      const selectedUserInputFlow = userInputFlowListElement.val()
      toggleUserInputFlowList(selectedUserInputFlow, oldData)

      userInputFlowListElement.on('change', function() {
        toggleUserInputFlowList(this.value, oldData)
      })
    },

    preConfirm: () => {
      const buttonWebhookUrl = $('#inputflow-webhook-url').val()
      const userInputFlowIdValue = $('#user-input-flow-list').val()
      const userInputFlowIdText = $( "#user-input-flow-list option:selected" ).text()
      const campaignName = $('#campaign-name').val()

      const googleSheets = $('#inputflow-google-sheets').val()
      const google_sheets_text = $('#inputflow-google-sheets option:selected')      
      const googleSheetsArray = selectedOptionsTextArray(google_sheets_text) 
      
      if (! userInputFlowIdValue) {
        Swal.showValidationMessage(lang.user_input_flow_modal_msg_flow)
      }
      
      if ('new' === userInputFlowIdValue) {
        if (!campaignName) {
          Swal.showValidationMessage("Choose a campaign name.")
        }
      }

      return {
        userInputFlowIdValue, 
        userInputFlowIdText,
        campaignName,
        buttonWebhookUrl,
        googleSheets,
        googleSheetsArray
      }
    },
  })
}